(function () {
  class PluginUpsellOverlay {
    constructor(root) {
      this.root = root;
      this.pluginVariantId = Number(root.dataset.pluginVariantId || 0);
      this.pluginSellingPlanId = root.dataset.pluginSellingPlanId
        ? String(root.dataset.pluginSellingPlanId)
        : "";
      this.pluginRequiresSellingPlan =
        root.dataset.pluginRequiresSellingPlan === "true";
      this.cartAddUrl = root.dataset.cartAddUrl || "/cart/add";
      this.checkoutUrl = root.dataset.checkoutUrl || "/checkout";
      this.successMessage =
        root.dataset.successMessage || "Complemento anadido correctamente.";
      this.errorMessage =
        root.dataset.errorMessage ||
        "No se pudo completar la accion. Intentalo de nuevo.";
      this.loadingLabel = root.dataset.loadingLabel || "Procesando...";

      this.compactButton = root.querySelector("[data-plugin-add]");
      this.compactOpenModalButton = root.querySelector("[data-plugin-open-modal]");
      this.modal = root.querySelector("[data-plugin-modal]");
      this.confirmButton = root.querySelector("[data-plugin-confirm]");
      this.skipButton = root.querySelector("[data-plugin-skip]");
      this.closeButtons = root.querySelectorAll("[data-plugin-close]");
      this.toast = root.querySelector(".plugin-upsell__toast");
      this.fadeDescriptionWrappers = root.querySelectorAll(
        ".plugin-upsell__modal-description-wrap--fade",
      );

      this.form = this.findProductForm();
      this.checkoutBlock = null;
      this.observer = null;
      this.isBusy = false;
      this.toastTimeout = null;

      if (!this.pluginVariantId || !this.form) return;

      this.handleCompactAdd = this.handleCompactAdd.bind(this);
      this.handleConfirm = this.handleConfirm.bind(this);
      this.handleSkip = this.handleSkip.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleEscape = this.handleEscape.bind(this);
      this.handleBuyNowClick = this.handleBuyNowClick.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleCompactOpenModal = this.handleCompactOpenModal.bind(this);
      this.handleDescriptionScroll = this.handleDescriptionScroll.bind(this);

      this.mount();
    }

    mount() {
      this.closeModal();

      if (this.compactButton) {
        this.compactButton.addEventListener("click", this.handleCompactAdd);
      }
      if (this.compactOpenModalButton) {
        this.compactOpenModalButton.addEventListener(
          "click",
          this.handleCompactOpenModal,
        );
      }
      if (this.confirmButton) {
        this.confirmButton.addEventListener("click", this.handleConfirm);
      }
      if (this.skipButton) {
        this.skipButton.addEventListener("click", this.handleSkip);
      }

      this.closeButtons.forEach((button) =>
        button.addEventListener("click", this.handleClose),
      );

      document.addEventListener("keydown", this.handleEscape);
      this.form.addEventListener("submit", this.handleFormSubmit, true);

      this.fadeDescriptionWrappers.forEach((wrapper) => {
        const description = wrapper.querySelector(
          ".plugin-upsell__modal-description",
        );
        if (!description) return;
        description.addEventListener("scroll", this.handleDescriptionScroll, {
          passive: true,
        });
      });
      this.updateDescriptionFade();

      this.bindBuyNowButtons();
      this.observeBuyNowButtons();
    }

    findProductForm() {
      const mainProduct = document.querySelector('[id^="MainProduct-"]');
      if (mainProduct) {
        const form = mainProduct.querySelector('form[data-type="add-to-cart-form"]');
        if (form) return form;
      }
      return document.querySelector('form[data-type="add-to-cart-form"]');
    }

    bindBuyNowButtons() {
      const wrapper = this.form.closest("product-form");
      this.checkoutBlock =
        (wrapper && wrapper.querySelector(".product-form__checkout")) ||
        this.form.querySelector(".product-form__checkout") ||
        document.querySelector(".product-form__checkout");

      if (!this.checkoutBlock) return;

      const buyNowButtons = this.checkoutBlock.querySelectorAll(
        ".shopify-payment-button__button",
      );

      buyNowButtons.forEach((button) => {
        if (button.dataset.pluginUpsellBound === "true") return;
        button.dataset.pluginUpsellBound = "true";
        button.addEventListener("click", this.handleBuyNowClick, true);
      });
    }

    observeBuyNowButtons() {
      if (!this.checkoutBlock) return;
      this.observer = new MutationObserver(() => this.bindBuyNowButtons());
      this.observer.observe(this.checkoutBlock, {
        childList: true,
        subtree: true,
      });
    }

    handleBuyNowClick(event) {
      this.stopEvent(event);
      this.openModal();
    }

    handleFormSubmit(event) {
      const submitter = event.submitter || document.activeElement;
      if (!submitter || !submitter.closest(".shopify-payment-button")) return;
      this.stopEvent(event);
      this.openModal();
    }

    handleCompactOpenModal(event) {
      this.stopEvent(event);
      if (this.isBusy) return;
      this.openModal();
    }

    async handleCompactAdd() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.setLoadingState(this.compactButton, true);

      try {
        await this.addPluginProduct(true);
        this.showToast(this.successMessage, false);
      } catch (error) {
        console.error(error);
        this.showToast(this.errorMessage, true);
      } finally {
        this.setLoadingState(this.compactButton, false);
        this.isBusy = false;
      }
    }

    async handleConfirm() {
      await this.processCheckoutFlow(true);
    }

    async handleSkip() {
      await this.processCheckoutFlow(false);
    }

    async processCheckoutFlow(includePlugin) {
      if (this.isBusy) return;
      this.isBusy = true;

      const activeButton = includePlugin ? this.confirmButton : this.skipButton;
      this.setLoadingState(activeButton, true);
      this.toggleModalButtons(true);

      try {
        await this.addMainProduct();
        if (includePlugin) {
          await this.addPluginProduct(false);
        }
        window.location.href = this.checkoutUrl;
      } catch (error) {
        console.error(error);
        this.showToast(this.errorMessage, true);
        this.closeModal();
      } finally {
        this.setLoadingState(activeButton, false);
        this.toggleModalButtons(false);
        this.isBusy = false;
      }
    }

    async addMainProduct() {
      const formData = new FormData(this.form);
      const variantInput = this.form.querySelector('[name="id"]');
      if (!formData.get("id") && variantInput) {
        formData.set("id", variantInput.value);
      }
      if (!formData.get("quantity")) {
        formData.set("quantity", "1");
      }
      return this.postAddToCart(formData, false);
    }

    async addPluginProduct(updateCartUi) {
      if (this.pluginRequiresSellingPlan && !this.pluginSellingPlanId) {
        throw new Error(
          "Subscription-only plugin product requires a selling plan id.",
        );
      }

      const formData = new FormData();
      formData.set("id", String(this.pluginVariantId));
      formData.set("quantity", "1");
      if (this.pluginSellingPlanId) {
        formData.set("selling_plan", this.pluginSellingPlanId);
      }
      return this.postAddToCart(formData, updateCartUi);
    }

    async postAddToCart(formData, updateCartUi) {
      const cart = updateCartUi ? this.getCartElement() : null;
      if (cart && typeof cart.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cart.getSectionsToRender().map((section) => section.id),
        );
        formData.append("sections_url", window.location.pathname);
        if (typeof cart.setActiveElement === "function") {
          cart.setActiveElement(document.activeElement);
        }
      }

      const response = await fetch(this.cartAddUrl, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || "Cart add failed");
      }

      if (cart && typeof cart.renderContents === "function") {
        cart.renderContents(data);
        if (cart.classList.contains("is-empty")) {
          cart.classList.remove("is-empty");
        }
      }

      return data;
    }

    getCartElement() {
      return (
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer")
      );
    }

    openModal() {
      if (!this.modal) return;
      this.modal.hidden = false;
      this.root.classList.add("is-modal-open");
      document.documentElement.classList.add("plugin-upsell-lock");
      window.requestAnimationFrame(() => this.updateDescriptionFade());
      if (this.confirmButton) this.confirmButton.focus();
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      this.root.classList.remove("is-modal-open");
      document.documentElement.classList.remove("plugin-upsell-lock");
    }

    handleClose() {
      if (this.isBusy) return;
      this.closeModal();
    }

    handleEscape(event) {
      if (event.key !== "Escape" || !this.root.classList.contains("is-modal-open")) {
        return;
      }
      if (this.isBusy) return;
      this.closeModal();
    }

    toggleModalButtons(disabled) {
      if (this.confirmButton) this.confirmButton.disabled = disabled;
      if (this.skipButton) this.skipButton.disabled = disabled;
    }

    setLoadingState(button, isLoading) {
      if (!button) return;
      if (!button.dataset.defaultLabel) {
        button.dataset.defaultLabel = button.textContent.trim();
      }
      button.disabled = isLoading;
      if (isLoading) {
        button.classList.add("is-loading");
        button.textContent = this.loadingLabel;
      } else {
        button.classList.remove("is-loading");
        button.textContent = button.dataset.defaultLabel;
      }
    }

    showToast(message, isError) {
      if (!this.toast || !message) return;
      if (this.toastTimeout) {
        window.clearTimeout(this.toastTimeout);
      }
      this.toast.textContent = message;
      this.toast.classList.toggle("is-error", Boolean(isError));
      this.toast.classList.add("is-visible");
      this.toastTimeout = window.setTimeout(() => {
        this.toast.classList.remove("is-visible");
      }, 3200);
    }

    handleDescriptionScroll() {
      this.updateDescriptionFade();
    }

    updateDescriptionFade() {
      this.fadeDescriptionWrappers.forEach((wrapper) => {
        const description = wrapper.querySelector(
          ".plugin-upsell__modal-description",
        );
        if (!description) return;
        const canScroll = description.scrollHeight - description.clientHeight > 2;
        const isAtBottom =
          description.scrollTop + description.clientHeight >=
          description.scrollHeight - 2;
        wrapper.classList.toggle(
          "is-fade-visible",
          canScroll && !isAtBottom,
        );
      });
    }

    stopEvent(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
    }
  }

  function initPluginUpsell(scope) {
    const target = scope || document;
    const overlays = target.querySelectorAll("[data-plugin-upsell-overlay]");
    overlays.forEach((overlay) => {
      if (overlay.dataset.pluginUpsellMounted === "true") return;
      overlay.dataset.pluginUpsellMounted = "true";
      new PluginUpsellOverlay(overlay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initPluginUpsell(document);
    });
  } else {
    initPluginUpsell(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initPluginUpsell(event.target);
  });
})();
